import React from "react";
import { Leaf, Cog, Package, BarChart3 } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/motion/Reveal";
import { CTASection } from "../components/home/FinancialBenefits";

const ICONS = [Leaf, Cog, Package, BarChart3];

export default function AgriculturalModel() {
  const { t } = useLang();
  return (
    <>
      <SEO pageKey="agricultural-model" title={t.seo.agricultural.title} description={t.seo.agricultural.description} />
      <PageHeader pageKey="agricultural-model"
        overline={t.agri.overline}
        title={t.agri.title}
        sub={t.agri.intro}
        image="https://images.unsplash.com/photo-1473968512647-3e447244af8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />
      <section className="py-10 sm:py-14 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <Stagger className="grid grid-cols-2 lg:grid-cols-4 gap-0">
            {t.agri.features.map((f, i) => {
              const Icon = ICONS[i];
              return (
                <StaggerItem key={i}>
                  <div className="group bg-lightgray border border-white p-4 sm:p-8 h-full hover:bg-green transition-colors duration-500" data-testid={`agri-feature-${i}`}>
                    <span className="w-9 h-9 sm:w-12 sm:h-12 rounded-xl bg-white flex items-center justify-center mb-3 sm:mb-6 shadow-sm">
                      <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-green-light" />
                    </span>
                    <h3 className="font-display text-base sm:text-xl text-charcoal group-hover:text-white transition-colors mb-1.5 leading-tight">{f.t}</h3>
                    <p className="text-charcoal/55 group-hover:text-white/80 transition-colors text-[11px] sm:text-sm leading-snug sm:leading-relaxed">{f.d}</p>
                  </div>
                </StaggerItem>
              );
            })}
          </Stagger>

          <Reveal delay={0.1}>
            <div className="mt-16 rounded-3xl overflow-hidden hover-zoom">
              <img src="https://images.unsplash.com/photo-1445264718234-a623be589d37?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="Managed agriculture" className="w-full h-[420px] object-cover" />
            </div>
          </Reveal>
        </div>
      </section>
      <CTASection />
    </>
  );
}
